<template>
<!--  查询处方 2023年9月20日 fleet-->
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap ">
        <el-table-column
                prop="consultStatusDescription"
                label="状态"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="consultGroupNo"
                label="编号"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="consultGroupType"
                label="申请类型"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="consulterName"
                label="患者"
                class="table-column"
                align="center">
        </el-table-column>
        <el-table-column
                prop="consulterGender"
                label="性别"
                :formatter="sexSelect"
                class="table-column"
                align="center">
        </el-table-column>
        <el-table-column
                prop="consulterAge"
                label="年龄"
                class="table-column"
                align="center">
        </el-table-column>
        <el-table-column
                prop="initDocName"
                label="申请医生"
                align="center"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="initDeptName"
                label="申请科室"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initHosName"
                label="申请机构"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="申请时间"
                :formatter="formatUnix"
                align="center"
                width="60"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="consultTime"
                label="会诊时间"
                :formatter="formatUnixConsultTime"
                align="center"
                width="60"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="modifierName"
                label="最后处理人"
                align="center"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="modifyTime"
                label="最后处理时间"
                :formatter="formatModifyUnix"
                align="center"
                width="90"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="operation"
                label=" 操作"
                align="center"
                inline-template
                class="table-column"
                width="180">
            <div class="table-btn-wrap">
                <el-button
                        size="small"
                        @click="linkToView($index, row)"
                        class="table-btn ghost-btn">
                    会诊单
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        @click="linkToDeal($index, row)"
                        class="table-btn operate">
                    处理
                </el-button>
            </div>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
    import { Table,Button,TableColumn, Tooltip } from "element-ui";
    import { formatUnixTime } from "../../utils/DateFormat.js"
    import Vue from "vue";
    Vue.use(Table);
    Vue.use(Button);
    Vue.use(TableColumn);
    Vue.use(Tooltip);
    export default{
        props: ["propsTableData"],
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                return formatUnixTime(row.createTime, "MM-dd HH:mm");
            },
            formatUnixConsultTime: function (row, column) {
                if(row.consultTime){
                    return formatUnixTime(row.consultTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            sexSelect: function(row, column){//根据服务器获取到的M或者其他显示男或女
                return (row.consulterGender =="M"?"男":"女");
            },
            formatModifyUnix: function(row, column){//格式化最后处理时间格式
                if(row.modifyTime){
                    return formatUnixTime(row.modifyTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            linkToView: function($index, row){
                this.$router.push({ name: "remoteSheet", params: { consultId: row.consultId }} );
            },
            linkToDeal: function($index, row){
                this.$router.push({ name: "remoteEvaluate", params: { consultId: row.consultId }} );
            }
        }
    }
</script>
